import React, { useRef, useEffect, useState } from "react";

const ChatInput = ({ value, onChange, onSend, loading }) => {
  const textareaRef = useRef(null);
  const [sendHovered, setSendHovered] = useState(false);

  useEffect(() => {
    const el = textareaRef.current;
    if (!el) return;
    el.style.height = "auto";
    el.style.height = Math.min(el.scrollHeight, 140) + "px";
  }, [value]);

  useEffect(() => {
    if (!loading) {
      textareaRef.current?.focus();
    }
  }, [loading]);

  const handleKeyDown = (e) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      if (!loading && value.trim()) {
        onSend();
        textareaRef.current?.focus();
      }
    }
  };

  const handleSendClick = () => {
    onSend();
    textareaRef.current?.focus();
  };

  const isDisabled = loading || !value.trim();
  const sendBtnStyle = {
    backgroundColor: isDisabled ? "#e5e7eb" : sendHovered ? "#0f766e" : "#0d9488",
    cursor: isDisabled ? "not-allowed" : "pointer",
    transition: "background-color 150ms",
  };

  return (
    <div className="flex-shrink-0 border-t border-gray-100" style={{ backgroundColor: "#f7f8fa" }}>
      <div className="max-w-2xl mx-auto w-full px-4 md:px-6 py-4">
        <div className="flex items-center gap-3 bg-gray-50 border border-gray-200 rounded-2xl px-6 md:px-4 py-3 shadow-sm">
          <textarea
            ref={textareaRef}
            rows={1}
            value={value}
            onChange={(e) => onChange(e.target.value)}
            onKeyDown={handleKeyDown}
            placeholder="Type your message..."
            disabled={loading}
            className="scrollbar-width flex-1 bg-gray-50 text-xs mb-0 text-gray-800 placeholder-gray-500 outline-none resize-none leading-6 disabled:opacity-50"
            style={{ minHeight: "20px", maxHeight: "100px" }}
          />

          <button
            onClick={handleSendClick}
            disabled={isDisabled}
            onMouseEnter={() => setSendHovered(true)}
            onMouseLeave={() => setSendHovered(false)}
            className="flex-shrink-0 w-7 h-7 rounded-full flex items-center justify-center text-white shadow-sm"
            style={sendBtnStyle}
            title="Send (Enter)"
          >
            {loading ? (
              <svg className="animate-spin" width="15" height="15" viewBox="0 0 24 24" fill="none">
                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="3" />
                <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z" />
              </svg>
            ) : (
              <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                <line x1="12" y1="19" x2="12" y2="5" />
                <polyline points="5 12 12 5 19 12" />
              </svg>
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ChatInput;
